import styled from "styled-components";
export const StyledHeader = styled.header`
    width: 100%;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
    background: #ffffff;
    position: fixed;
    top: 0;
    height: 5rem;
    z-index: 10000;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0;
    margin: 0;
    @media only screen and (min-width: 600px) {
      justify-content: center;
    }
    @media only screen and (min-width: 721px) {
      .mobile-AccessibilityMenu-show {
        display: none;
      }
    }
    @media only screen and (max-width: 720px) {
      .desktop-AccessibilityMenu-show {
        display: none;
      }
      .mobile-AccessibilityMenu-show {
        position: absolute;
        right: 0rem;
        top: 5rem;
        z-index: 5;
      }
    }
  `,
  StyledLink = styled.a`
    display: none;
    @media (min-width: 600px) {
      display: flex;
      text-decoration: none;
      color: ${(props) => (props.color === "blue" ? "#083f88" : "#00aae4")};
      cursor: pointer;

      margin: 0vw 0.75vw;
      white-space: nowrap;
      font-size: 14px;
      transition: color 0.4s;
      &:hover {
        color: ${({ color }) => (color === "blue" ? "#00aae4" : "#083f88")};
      }
    }
    @media only screen and (min-width: 600px) {
      margin: 0rem 1vw;
    }
    @media only screen and (min-width: 1000px) {
      font-size: 1.25vw;
    }
    @media only screen and (min-width: 600px) and (max-width: 640px) {
      font-size: 12px;
    }
  }
  
  `,
  Logo = styled.img`
    padding: 0;
    margin: 0;
    padding: 0 1rem;
    height: 2.5rem;
    cursor: pointer;
    margin-right:3rem;
    @media only screen and (min-width: 600px) {
      height: 2rem;
    }
    @media only screen and (min-width: 600px) and (max-width: 720px){
      width:145px;
      margin-right:2rem;
    }
    @media only screen and (min-width: 320px) and (max-width: 600px){
     
      margin-right:0.6rem;
       
    }
    @media only screen and (min-width: 320px) and (max-width: 400px){
      margin-right:1.6rem;
      width:140px;
    }
    @media only screen and (min-width: 400px) and (max-width: 480px){
      margin-right:0.5rem;
      margin-left:-1rem;
  
    }
    @media only screen and (min-width: 1000px) {
      height: 4vw;
    }
    @media only screen and (min-width: 320px) and (max-width: 375px){
        height: 1.8rem;
        padding-left:0.5rem;
      }
    @media only screen and (min-width: 375px) and (max-width:400px) {
          height: 2rem;
          padding-left:0.5rem;
        }
        @media only screen and (min-width: 401px)  and (max-width: 450px){
          height: 2.2rem;
          padding-left:1rem;
        }
        @media only screen and (min-width: 451px)  and (max-width: 580px){
          height: 2.5rem;
          padding-left:1rem;
        }
        @media only screen and (min-width: 576px)  and (max-width: 599.7px){
         height: 2.5rem;
          padding-left:2rem;
         }
  `,
  Menu = styled.img`
  padding: 0.8vw 0.8vw 0.8vw 0.8vw;
  height: 1.7rem;
  cursor: pointer;
  border: 1.2px solid Grey;
  border-radius: 50%;
  width: 1.8rem;
    @media (min-width: 600px) {
      display: none;
    }
    @media only screen and (min-width: 375px) and (max-width:500px) {
      margin-left:1rem;
    }
    @media only screen and (min-width: 401px)  and (max-width: 599px){
      height: 2.4rem;
    border-radius: 50%;
    width: 2.4rem;
    padding: 0.8vw 1vw 0.8vw 1.3vw;
    }
    @media only screen and (min-width: 501px)  and (max-width: 550px){
      margin-left:4rem;
    }
    @media only screen and (min-width: 551px)  and (max-width: 599.7px){
      margin-left:6rem;
    }
  `;


